import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Estimate } from 'src/app/models/Estimate';
import { environment } from 'src/environments/environment';
import { httpOptions } from "./headers";

@Injectable({
  providedIn: 'root'
})
export class ProjectsService {



  private projectUrl = environment.projectUrl;

  private httpOptions(session: string) {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', 'Authorization': 'Bearer ' + session
      }),
    };
  };

  constructor(private http: HttpClient) { }

  getProjects() {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.get<any>(this.projectUrl + "/me", this.httpOptions(token));
  }

  addProject(projectName: String, region: string, maintenancePct: number = 0) {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.post<any>(this.projectUrl + "/create", { name: projectName, region: region, maintenancePct }, this.httpOptions(token));
  }

  getProjectById(id: string) {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.get<any>(this.projectUrl + "/" + encodeURIComponent(id), this.httpOptions(token));
  }

  addUserToProject(projectId: string, userName: string, userEmail: string) {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.put<any>(this.projectUrl + '/' + encodeURIComponent(projectId) + '/add-user', {
      name: userName,
      email: userEmail
    }, this.httpOptions(token));
  }


  editUserInProject(projectId: string, userName: string, userEmail: string, index: number) {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.put<any>(this.projectUrl + '/' + encodeURIComponent(projectId) + '/edit-user/' + encodeURIComponent(index), {
      name: userName,
      email: userEmail
    }, this.httpOptions(token));
  }

  removeUserFromProject(projectId: string, userName: string, userEmail: string) {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.put<any>(this.projectUrl + '/' + encodeURIComponent(projectId) + '/remove-user', {
      name: userName,
      email: userEmail
    }, this.httpOptions(token));
  }

  editProject(projectId: string, projectName: string, region: string, active: boolean, maintenancePct?: number) {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    const body: any = { name: projectName, active, region };
    if (maintenancePct !== undefined) body.maintenancePct = maintenancePct;
    return this.http.put<any>(this.projectUrl + '/' + encodeURIComponent(projectId), body, this.httpOptions(token));
  }

  updateInitialCost(projectId: string, value: number) {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.patch<any>(this.projectUrl + '/' + encodeURIComponent(projectId) + '/initial-cost', {
      initialCost: value
    }, this.httpOptions(token));
  }

  getActiveProjects() {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.get<any>(this.projectUrl + '/me/active', this.httpOptions(token));
  }

  deleteProject(projectId: string) {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.delete<any>(this.projectUrl + '/' + encodeURIComponent(projectId), this.httpOptions(token));
  }

  getUserProjects(dasID: string) {
    return this.http.get<any>(this.projectUrl + '/user?id=' + encodeURIComponent(dasID), httpOptions);
  }

  getProjectsByUser() {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.get<any>(this.projectUrl + '/me', this.httpOptions(token));
  }


  addNewProject(project: any) {
    return this.http.post<any>(this.projectUrl, project, httpOptions);
  }

  updateProject(project: any): Subscription {

    return this.http.put<any>(this.projectUrl + '/' + project.id, project, httpOptions).subscribe();
  }

  updateProjectEstimates(estimates: Estimate[]): Observable<any> {
    return this.http.put<any>(this.projectUrl + '/updateProjectEstimate', estimates, httpOptions);
  }

  getProjectUsers(projectId: string) {
    const token = JSON.parse(sessionStorage.getItem('authToken') as string).token;
    return this.http.get<any>(this.projectUrl + '/' + encodeURIComponent(projectId) + '/users', this.httpOptions(token));
  }
}
